import { SHOP_LOCALE_COOKIE, type LocaleResolutionOptions, type ShopLocale } from './shared'
import { normalizeShopLocale } from './normalization'

export const readLocaleFromCookieHeader = (
  cookieHeader: string | undefined,
  options?: LocaleResolutionOptions,
): ShopLocale | null => {
  if (!cookieHeader) return null
  const pairs = cookieHeader.split(';')
  for (const pair of pairs) {
    const [rawKey, ...rawValue] = pair.split('=')
    if (rawKey?.trim() !== SHOP_LOCALE_COOKIE) continue
    const decodedValue = decodeURIComponent(rawValue.join('=').trim())
    const locale = normalizeShopLocale(decodedValue, options)
    if (locale) return locale
  }
  return null
}

export const readLocaleFromDocumentCookie = (options?: LocaleResolutionOptions): ShopLocale | null => {
  if (typeof document === 'undefined') return null
  return readLocaleFromCookieHeader(document.cookie, options)
}

export const writeLocaleCookie = (locale: ShopLocale) => {
  if (typeof document === 'undefined') return
  const expiresInSeconds = 60 * 60 * 24 * 365
  const secure =
    typeof window !== 'undefined' &&
    (window.location.protocol === 'https:' ||
      (typeof process !== 'undefined' &&
        typeof process.env?.NODE_ENV === 'string' &&
        process.env.NODE_ENV === 'production'))
  const secureSuffix = secure ? '; secure' : ''
  document.cookie = `${SHOP_LOCALE_COOKIE}=${encodeURIComponent(locale)}; path=/; max-age=${expiresInSeconds}; samesite=lax${secureSuffix}`
}
